import { muiTheme } from '@tassat/payments-themes';

const muiStyles = (theme: typeof muiTheme) => ({
    fullWidth: {
        width: '100%',
        alignSelf: 'center' as 'center'
    },
    flexColumn: {
        display: 'flex',
        flexFlow: 'column nowrap'
    },
    submitButton: {
        alignSelf: 'center',
        marginTop: '2.5rem'
    },
    submitError: { alignSelf: 'center' },
    walletAddressContainer: { marginBottom: '1.25rem' },
    walletAddressLabel: {
        display: 'block',
        marginBottom: '.25rem'
    },
    walletAddressText: {
        fontFamily: 'client-font,sans-serif',
        fontSize: '1.1rem'
    },
    firmName: {
        fontFamily: 'client-font,sans-serif',
        fontSize: '24px',
        color: theme?.app?.applicationColors.enumColors.black || '#000000',
        lineHeight: '20px',
        fontWeight: 600,
        marginRight: '5px',
        marginBottom: '30px'
    },
    inputLabel: {
        fontFamily: 'client-font,sans-serif',
        fontSize: '14px',
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073'
    },
    nickNamesText: {
        fontFamily: 'client-font,sans-serif',
        fontSize: '18px',
        color: theme?.app?.applicationColors.fontDetailColor || '#4A4C50',
        marginTop: '13px',
        wordBreak: 'break-all' as const
    },
    firmAndFavorite: { display: 'flex' },
    hidden: { display: 'none' as 'none' },
    apiEnabled: {
        '& label': { alignItems: 'flex-end' },
        '& span': {
            border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#CFCFCF'}`,
            borderRadius: '3px'
        }
    },
    associatedAccountNumber: { paddingRight: '0px !important' },
    associatedAccountNumberLabel: {
        color: theme?.app?.clientTheme.colors.primaryColor + ' !important' || '#375073 !important',
        fontSize: '14px'
    }
});

export default muiStyles;